import React, { Component } from 'react'
import moment from 'moment'
import DOMPurify from 'dompurify';

import Logo from '../common/logo'
import './landing.css'

export default class LandingPageCA extends Component {
  constructor(props) {
    super(props)
    this.next = this._next.bind(this)
  }

  joinSocial() {
    return (
      <div className="intro-join">
        <a className="intro-social" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/newtopiahealth/">
          <img src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/e3a02b29-a0f7-4012-bf5e-06531b325291.png?b=1518538744000" alt="facebook" />
        </a>
        <a className="intro-social" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/NewtopiaHealth/">
          <img src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/0aef2217-8f57-4a0f-a825-715697ca2b09.png?b=1518538744000" alt="instagram" />
        </a>
        <span className="join-text">
          Join us on <a className="social-word-link" target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/newtopiahealth/">Facebook</a> and <a className="social-word-link" target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/NewtopiaHealth/">Instagram</a>  to get tips on how to improve your nutrition, exercise, and well-being.
        </span>  
      </div>
    )
  }

  introConditional() {
    const todayDate = moment()
    const { registrationOpenDate, registrationCloseDate, clientText, registrationClosedText, comingSoonText } = this.props 
    const joinSocial = this.joinSocial()
    let openDate = registrationOpenDate
    let closeDate = registrationCloseDate
    let purifiedHTML = DOMPurify.sanitize(clientText, { ADD_ATTR: ['target'] });
    if (!registrationOpenDate) openDate = false
    if (!registrationCloseDate) closeDate = false
    if (closeDate && todayDate >= closeDate) {
      return (
          <div className="intro-conditional flex">
            <h2 className="intro-title">Personalized coaching for lasting good health</h2>
            <h3 className="closed-title">{registrationClosedText}</h3>
            <p dangerouslySetInnerHTML={{ __html: purifiedHTML}}></p>
            {joinSocial}
          </div>
        )
    }
    else if (!openDate || todayDate < openDate) {
      return (
        <div className="intro-conditional flex">
          <h2 className="intro-title">Personalized coaching for lasting good health</h2>
          <h3 className="soon-title">{comingSoonText}</h3>
          {joinSocial}
        </div>
      ) 
    } else {
      return (
        <div className="intro-conditional flex">
          <h2 className="intro-title">Personalized coaching for lasting good health</h2>
          <p className="program-descript">You’ll work with your coach to introduce habit changes to achieve your goals, improve your nutrition, increase activity and focus on your mental health.</p>
          <button className="button join" onClick={this.next}>GET STARTED NOW</button>
          <p>There is no cost to you and your privacy is 100% guaranteed</p>
          <p dangerouslySetInnerHTML={{ __html: purifiedHTML}}></p>
          {joinSocial}
        </div>
      )
    } 
  }

  brandDisplay() {
    const { client, clientImg, clientImgText} = this.props
    let purifiedHTML = (!!clientImgText && clientImgText.trim()) ? DOMPurify.sanitize(clientImgText) : '<p>Newtopia is offered as part of the ' + client + '’s health and well-being program.</p>'
    if (!client) {
      return (
        <div className="brand-container">
        </div>
      )
    } else {
      return (
        <div className="brand-container">
          <img src={clientImg} alt="client logo" />
          <div dangerouslySetInnerHTML={{ __html: purifiedHTML}}/>
        </div>
      )
    }
  }

  _next() {
    return this.props.next()
  }

  componentDidMount() {
    var focusable = document.querySelectorAll('[tabindex]:not([tabindex="-1"])');
    focusable && focusable[0] && focusable[0].focus() 
    window.scrollTo(0, 0)
    if (window.location.hash) {
      window.location.href = window.location.hash;
    }
  }

  render() {
    const introConditional = this.introConditional()
    const brandDisplay = this.brandDisplay()
    return (
      <div>
        <div className="landing-header">
          <div>
            <Logo/>
            <div className="menu-container">
              <div className="menu-social">
                <a target="_blank" rel="noopener noreferrer" href="https://www.facebook.com/newtopiahealth/">
                  <img src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/699eac18-91fd-4ab6-ab43-f79ff6e2666f.png?b=1518544011000" alt="facebook" />
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.instagram.com/NewtopiaHealth/">
                  <img src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/909f7323-4473-4d5a-aae1-42761aa02735.png?b=1518544011000" alt="instagram" />
                </a>
                <a target="_blank" rel="noopener noreferrer" href="https://www.youtube.com/channel/UClXxA4PvRsyDX7ygp4DjJrw">
                  <img src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/74fc36be-cf39-4dc7-b165-5cf4ebaf9087.png?b=1518544011000" alt="youtube" />
                </a>
              </div>
              <div className="menu-anchors">
                <a id="landing_chatter" href="#chatter">Chatter</a>
                <a id="landing_how" href="#how">How It Works</a>
                <a id="landing_contacts" href="#contacts">Contact Us</a>
              </div>
            </div>
          </div>
        </div>

        <div className="landing-intro-ca">
          <div className="intro-block"> 
            {introConditional}
            <img className="bicycle-girl flex" src="https://start.newtopia.com/registration/Pages/Eastern-Landing-Intro.png" alt="Ship passing lighthouse"/>
          </div>
        </div>

        {brandDisplay}
        <div className="landing-component-container">
          <div id="chatter" name="chatter" className="anchor-link"/>
          <h2 className="h2-participants">Here's what our participants are saying.</h2>
          <div className="participant-containers">
            <div className="testimonial">
              <img className="participant" src="https://start.newtopia.com/registration/Landing/Eastern-Testimonial-Circle1.png" alt="participant 1" />
              <p className="description-2">"The support from my Inspirator made a big difference in my life. I was able to reduce my A1C from 15.9 to a healthy level in just six months! It was all due to me changing how I eat. I am more aware of not only what I eat and how I eat, but how exercise and movement can be so important to me."</p>
            </div>
            <div className="testimonial">
              <img className="participant" src="https://start.newtopia.com/registration/Landing/Eastern-Testimonial-Circle2.png" alt="participant 2" />
              <p className="description-2">"When I started this journey, I did not believe that I could be successful in a healthier lifestyle. I would have anxiety because my numbers (A1C) were creeping up. My weight was also going up year over year. When I began to use the tools that my Inspirator shared, and the videos, I went from an A1C of 6.4 to 5.6. It was not an overnight fix; it was consistent and purposeful choices. Those choices became second nature, with the knowledge that I have gained through Newtopia."</p>
            </div>  
          </div>
          
          <div className="landing-video-container">
            <a className="video-link" target="_blank" rel="noopener noreferrer" href="https://youtu.be/cfMGYk4MXpk">
              <img className="play-button" src="https://image.s7.exacttarget.com/lib/fe9113727c60037c75/m/1/b00f7879-3fd9-4447-9fac-f03ed0831063.png" alt="video" />
              <span> See what others are saying </span>
            </a>
          </div>
        </div>  

        <div className="landing-component-container light-grey">
          <div id="how" name="how" className="anchor-link" />
          <h2 className="h2-landing">How it works</h2>
          <div>It's easy to get started with Newtopia. A few quick steps will get you a deeply personalized experience, complete with access to a personality-matched coach to support you and help you become your best self.</div>
          <div className="works-wrapper">
            <div className="works-block">
              <div className="works-item">  
                <img src="https://start.newtopia.com/registration/Landing/Newtopia_EH-ICON_small_Personal%20Profile.png" alt="personal profile" />
                <p className="works-description-1">Personal Profile</p>
                <p className="works-description-2">You’ll provide information about your personality, motivation level, eating habits and activity. This information will help to personalize your Inspirators recommendations.</p>
              </div>
              <div className="works-item">
                <img src="https://start.newtopia.com/registration/Landing/Newtopia_EH-ICON_small_Inspirator.png" alt="inspirator" />
                <p className="works-description-1">Personality Matched Inspirator</p>
                <p className="works-description-2">You’ll have live one on one coaching sessions that can be self-scheduled.</p>
              </div>
              <div className="works-item">
                <img src="https://start.newtopia.com/registration/Landing/Newtopia_EH-ICON_small_Personalized%20NEW.png" alt="personalized" />
                <p className="works-description-1">Personalized Program</p>
                <p className="works-description-2">You’ll build and develop habits around improving your nutrition, increasing your activity and focus on your overall well-being.</p>
              </div>  
            </div>
            <div className="works-block">
              <div className="works-item">
                <img src="https://start.newtopia.com/registration/Landing/Newtopia_EH-ICON_small_Tools.png" alt="devices" />
                <p className="works-description-1">Newtopia App and Smart Scale</p>
                <p className="works-description-2">Your scale will update your weight directly in your app. The app will provide progress updates and resources to support your  journey with video lessons, goals, and more.</p> 
              </div>
              <div className="works-item">
                <img src="https://start.newtopia.com/registration/Landing/Newtopia_EH-ICON_small_Community%20and%20Gaming.png" alt="games" />
                <p className="works-description-1">Gaming and Community</p>
                <p className="works-description-2">Through Newtopia's social channels you can chat with other participants, share successes, ideas and support one another. You’ll also participate in challenges through the app.</p>
              </div>
              <div className="works-item">
                <img src="https://start.newtopia.com/registration/Landing/Newtopia_EH-ICON_small_Best%20Self.png" alt="mountain peak" />
                <p className="works-description-1">Becoming Your Best Self</p>
                <p className="works-description-2">Through habit changes around improvement to your health you’ll start to look and feel your best!</p>
              </div>
            </div>
          </div>
        </div> 
      </div> 
    )
  }
}